<template>
  <div v-show="!showModal">
    <a-spin :spinning="loading">
      <a-form ref="form" :model="formState" name="form" @finish="onSearch">
        <a-row>
          <a-form-item class="ui-form__item" name="organizationId" label="影院组织">
            <a-select placeholder="请选择" v-model:value="formState.organizationId" style="width: 180px;"
                      @change="getAllCinemaList">
               <a-select-option :value="0">全部</a-select-option>
              <a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="ui-form__item" name="cinemaId" label="所属影院">
            <a-select placeholder="请选择" v-model:value="formState.cinemaId" style="width: 180px;">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="模板平台" name="platformFlag" class="ui-form__item">
            <a-select v-model:value="formState.platformFlag" placeholder="请选择模板平台" style="width: 190px;">
              <a-select-option :value="''">全部</a-select-option>
              <a-select-option :value="1">阿里云</a-select-option>
              <a-select-option :value="2">腾讯云</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="使用位置" name="platform" class="ui-form__item">
            <a-select v-model:value="formState.usePosition" placeholder="请选择模板平台" style="width: 190px;">
              <a-select-option :value="''">全部</a-select-option>
              <a-select-option :value="1">登录验证码短信</a-select-option>
              <a-select-option :value="2">购票失败短信</a-select-option>
              <a-select-option :value="3">重置会员卡密码短信</a-select-option>
              <a-select-option :value="4">预警信息</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="ui-form__item" name="secretId" label="secretId">
            <a-input v-model:value="formState.secretId" placeholder="请输入secretId"></a-input>
          </a-form-item>

          <a-form-item class="ui-form__item" name="secretKey" label="secretKey">
            <a-input v-model:value="formState.secretKey" placeholder="请输入secretKey"></a-input>
          </a-form-item>

          <a-form-item class="ui-form__item" name="signName" label="短信签名">
            <a-input v-model:value="formState.signName" placeholder="请输入短信签名"></a-input>
          </a-form-item>

          <a-form-item class="ui-form__item" name="短信模板" label="templateCode">
            <a-input v-model:value="formState.templateCode" placeholder="请输入短信模板"></a-input>
          </a-form-item>

          <a-form-item class="ui-form__item" label="创建时间" name="createTime">
            <a-range-picker :showTime="{ hideDisabledOptions: true, defaultValue:[moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"  v-model:value="formState.createTime" />
          </a-form-item>
        </a-row>

        <a-row>
          <a-col :span="18">
            <a-button type="primary" @click="onAdd">新增短信模板</a-button>
          </a-col>
          <a-col :span="6" style="text-align: right;">
            <a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
            <a-button @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>

      <div style="margin-top: 20px;">
        <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="list" tableLayout="fixed"
                 :scroll="{ x: 1100 }">
          <template #bodyCell="{ column, record, index }">

            <template v-if="column.dataIndex === 'cinemaName'">
              <div v-if="record.cinemaName || record.cinemaCode">
                {{ record.cinemaName }}
              </div>
              <div v-else> 默认 </div>
            </template>
            <template v-if="column.dataIndex === 'cinemaCode'">
              <div v-if="record.cinemaCode">
                {{ record.cinemaCode }}
              </div>
              <div v-else>--</div>
            </template>
            <template v-if="column.dataIndex === 'appId'">
              {{ record.appId || '--' }}
            </template>
            <template v-if="column.dataIndex === 'usePosition'">
              {{ usePosition[record.usePosition] }}
            </template>
            <template v-if="column.dataIndex === 'platformFlag'">
              {{ ['','阿里云','腾讯云'][record.platformFlag] }}
            </template>
            <template v-if="column.dataIndex === 'isDisabled'">
              {{ record.isDisabled ? '禁用' : '使用中' }}
            </template>
            <template v-if="column.dataIndex === 'createUserName'">
              {{ record.createUserName ? record.createUserName : '--' }}
            </template>
            <template v-if="column.dataIndex === 'createTime'">
              {{ record.createTime ? transDateTime(record.createTime) : '--' }}
            </template>
            <template v-if="column.dataIndex === 'updateTime'">
              {{ record.updateTime ? transDateTime(record.updateTime) : '--' }}
            </template>
            <template v-if="column.key === 'action'">
              <a-dropdown :trigger="['click', 'hover']">
                <a-button @click.prevent>操作 <Icon icon="DownOutlined"></Icon>
                </a-button>
                <template #overlay>
                  <a-menu>
                    <div @click="onEdit(record)">
                      <a-menu-item>
                        编辑
                      </a-menu-item>
                    </div>
                    <template v-if="record.cinemaCode">
                      <div v-if="record.isDisabled" @click="onDisabled(record)">
                        <a-menu-item>
                          启动
                        </a-menu-item>
                      </div>
                      <div v-else @click="onDisabled(record)">
                        <a-menu-item>
                          禁用
                        </a-menu-item>
                      </div>
                    </template>
                    <div @click="onDelete(record)" v-if="record.cinemaCode">
                      <a-menu-item>
                        删除
                      </a-menu-item>
                    </div>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </template>
        </a-table>
      </div>
    </a-spin>
  </div>
  <temp v-if="showModal" :isEdit="isEdit" :isSee="isSee" :id="id" @back="onBack"></temp>
</template>

<script>
  import temp from './temp.vue';
  import {
    Icon
  } from '@/components/icon/icon.js';

  import {
    getOrganizationList,
    getCinemaList,
  } from '@/service/modules/cinema.js';

  import {
    getSmsList,
    setSmsIsDisabled,
    deleteSms
  } from '@/service/modules/system.js';
  export default {
    components: {
      Icon,
      temp
    },
    data() {
      return {
        loading: false,
        isEdit: false,
        isSee: false,
        id: 0,
        storeId: 0,
        organizationList: [],
        cinemaAllList: [],
        formState: {
          organizationId: 0,
          cinemaId: 0,
        },
        searchData: {},
        showModal: false,
        list: [],
        columns: [{
          title: '影院',
          dataIndex: 'cinemaName',
          width: 150
        }, {
          title: '影院编码',
          dataIndex: 'cinemaCode',
          width: 100
        }, {
          title: '使用位置',
          dataIndex: "usePosition",
          width: 120
        }, {
          title: '模板平台',
          dataIndex: "platformFlag",
          width: 80
        }, {
          title: 'secretId',
          dataIndex: 'secretId',
          width: 200
        }, {
          title: 'secretKey',
          dataIndex: 'secretKey',
          width: 200
        }, {
          title: '短信签名',
          dataIndex: 'signName',
          width: 120
        }, {
          title: '短信模板',
          dataIndex: 'templateCode',
          width: 120
        }, {
          title: 'appId',
          dataIndex: 'appId',
          width: 120
        }, {
          title: '配置人',
          dataIndex: 'createUserName',
          width: 80
        }, {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 150
        }, {
          title: '修改时间',
          dataIndex: 'updateTime',
          width: 150
        }, {
          title: '状态',
          dataIndex: 'isDisabled',
          width: 80
        }, {
          title: '操作',
          key: 'action',
          width: 100,
          fixed: 'right'
        }
        ],
        pagination: {
          showSizeChanger: true,
          showQuickJumper: true,
          size: "middle",
          showTotal: (total) => {
            return "共 " + total + " 条";
          },
          total: 0,
          current: 1,
          pageSize: 10,
          onChange: (page) => {
            this.pagination.current = page;
            this.getData();
          },
          onShowSizeChange: (page, pageSize) => {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getData();
          }
        },
        showAddPopup: false,
        usePosition: {
          0: '全部',
          1: '登录验证码短信',
          2: '购票失败短信',
          3: '重置会员卡密码短信',
          4: '预警信息',
        }
      }
    },
    created() {
      this.getOrganizationList();
      // this.getAllCinemaList();
    },
    methods: {
      onBack(isRef) {
        this.showModal = false;
        if (isRef) {
          this.$nextTick(() => {
            this.getData();
          })
        }
      },
      onSearch() {
        this.pagination.current = 1;
        this.searchData = JSON.parse(JSON.stringify(this.formState));
        this.searchData.organizationId = this.searchData.organizationId ? this.searchData.organizationId : undefined;
        this.searchData.cinemaId = this.searchData.cinemaId ? this.searchData.cinemaId : undefined;
        this.getData();
      },
      reset() {
        this.$refs.form.resetFields();
        if (this.organizationList.length) {
          // this.formState.organizationId = this.organizationList[0].id;
          this.formState.organizationId = 0;
          this.formState.platformFlag = '';
          this.formState.usePosition = '';
          this.formState.secretId = '';
          this.formState.secretKey = '';
          this.formState.signName = '';
          this.formState.templateCode = '';
          this.getAllCinemaList(this.formState.organizationId);
        }
        this.onSearch();
      },
      async getData() {
        this.loading = true;
        try {
          let ret = await getSmsList({
            page: this.pagination.current,
            pageSize: this.pagination.pageSize,
            ...this.searchData
          })
          this.loading = false;
          if (ret.code === 200) {
            this.list = ret.data.list;
            this.pagination.total = ret.data.totalCount;
          }
        } catch (e) {
          this.loading = false;
        }
      },
      async getOrganizationList() {
        this.loading = true;
        try {
          let ret = await getOrganizationList({
            page: 1,
            pageSize: 999999
          });
          if (ret.code === 200) {
            this.organizationList = ret.data.list;
            if (this.organizationList.length) {
              // this.formState.organizationId = this.organizationList[0].id;
              this.getAllCinemaList();
              // this.getAllCinemaList(this.formState.organizationId);
            }
            this.getData();
          } else {
            this.loading = false;
          }
        } catch (e) {
          this.loading = false;
        }
      },
      async getAllCinemaList(organizationId) {
        this.cinemaAllList = [];
        // this.formState.id = 0;
        let ret = await getCinemaList({
          page: 1,
          pageSize: 999999,
          organizationId: organizationId ? organizationId : undefined
        })
        if (ret.code === 200) {
          this.cinemaAllList = ret.data.list;
        }
      },
      onDelete(item) {
        this.$confirm({
          title: '提示',
          content: '确定删除配置吗？',
          onOk: async () => {
            this.loading = true;
            try {
              let ret = await deleteSms({
                id: item.id,
                isDisabled: item.isDisabled ? 0 : 1
              })
              this.loading = false;
              if (ret.code === 200) {
                this.$message.success('删除成功');
                this.getData();
              }
            } catch(e) {
              console.log(e)
              this.loading = false;
            }
          }
        })
      },
      onDisabled(item) {
        this.$confirm({
          title: '提示',
          content: '确定' + (item.isDisabled ? '开启' : '关闭') + '该预警吗？',
          onOk: async () => {
            this.loading = true;
            try {
              let ret = await setSmsIsDisabled({
                id: item.id,
                isDisabled: item.isDisabled ? 0 : 1
              })
              this.loading = false;
              if (ret.code === 200) {
                this.$message.success((item.isDisabled ? '开启' : '关闭') + '成功');
                this.getData();
              }
            } catch(e) {
              console.log(e)
              this.loading = false;
            }
          }
        })
      },
      onAdd() {
        this.isEdit = false;
        this.id = 0;
        this.isSee = false;
        this.showModal = true;
      },
      onEdit(item) {
        this.isEdit = true;
        this.id = item.id;
        this.isSee = false;
        this.showModal = true;
      },
      onSee(item) {
        this.isEdit = true;
        this.id = item.id;
        this.isSee = true;
        this.showModal = true;
      },
    }
  }
</script>

<style>
    .ui-form__item {
        margin-right: 30px;
    }
</style>
